















































import moment from 'moment';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Conversation } from '../models/conversation';
import { conversationApi } from '../services/conversationApi';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import { ConversationMessage } from '../models/conversation-message';
import ChannelIcon from '@/shared/icons/ChannelIcon.vue';

@Component({
	components: { LoadingSpinner, ChannelIcon }
})
export default class ContactConversation extends Vue {
	@Prop() public conversation: Conversation;

	@Prop() public expanded: boolean;

	@Prop() public workspaceId: string;

	public maxConversationTitleLength = 50;

	public messages: any[] = [];

	public loading: boolean = false;

	public messageTrayOpen: boolean = false;

	public hasLoadedMessages: boolean = false;

	public mounted() {
		if (this.expanded) {
			this.toggleMessageTray();
		}
	}

	public get truncatedTitle(): string {
		if (!this.conversation.title) {
			return `Conversation on ${this.channelIdentityName}`;
		}
		return this.conversation.title.length > this.maxConversationTitleLength
			? this.conversation.title.substr(0, this.maxConversationTitleLength) + '...'
			: this.conversation.title;
	}

	public get conversationDate(): string {
		const date = new Date(this.conversation.createdTimeUtc);
		return moment(date).format('dddd Do MMMM');
	}

	public async getMessages() {
		this.loading = true;
		const response = await conversationApi.getConversationMessages(this.workspaceId, this.conversation.id);
		this.messages = response.messages?.map(message => ({
			type: this.getMessageType(message),
			text: this.getMessageText(message),
			direction: message.role === 'appUser' ? 'inbound' : 'outbound',
			status: message.status,
			timestampUtc: message.received,
			actions: message.actions ? message.actions.map(action => action.payload) : [],
			name: !message.name ? 'Unknown' : message.name,
			avatarUrl: message.avatarUrl,
			card: this.getMessageCard(message),
			mediaSrc: message.mediaUrl,
			fileName: message.mediaFilename,
			fileSize: message.mediaSize,
			fileType: message.mediaType,
		}));
		this.loading = false;
	}

	public get channelType(): string {
		return this.conversation.channelIdentity.type;
	}

	public get channelIdentityName(): string {
		switch (this.channelType) {
			case 'sms-bt':
				return 'BT Smart Messaging Tailored';
			case 'sms-govuknotify':
				return 'GOV.UK Notify SMS';
			case 'messenger':
				return 'Facebook Messenger';
			case 'twitter-dm':
				return 'Twitter';
			case 'instagram':
				return 'Instagram';
			case 'google-bm':
				return 'Google Business Messages';
			default:
				return 'Web Assistant';
		}
	}

	public getMessageType(m: ConversationMessage): string {
		if (m.role === 'whisper') {
			return 'whisper';
		}
		return m.type;
	}

	public getMessageText(m: ConversationMessage): string {
		if (m.role === 'whisper' && m.text) {
			return m.text;
		}

		if (m.role === 'whisper' && m.metadata) {
			return m.metadata.description;
		}

		if (m.type === 'text') {
			return m.text;
		}

		return '';
	}

	public getMessageCard(m: ConversationMessage): any {
		if (m.type === 'app' && m.app) {
			return { content: m.app.card };
		}
		return null;
	}

	public toggleMessageTray() {
		if (this.shouldLoadMessages()) {
			this.getMessages();
		}
		this.messageTrayOpen = !this.messageTrayOpen;
	}

	public shouldLoadMessages(): boolean {
		if (this.messageTrayOpen) {
			return false;
		}
		return !this.hasLoadedMessages || this.conversation.status === 'open';
	}

	public onLoad($state: any) {
		// Mark state as complete to hide the loader.on the conversation thread
		$state.complete();
	}
}
